/**
 * @generated SignedSource<<73ee3d1c922ef1e6630e2e2ed7d448b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SuiteAccessLevels = "MANAGE_AND_READ" | "READ_ONLY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Suites_team$data = {
  readonly suites: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly accessLevel: SuiteAccessLevels;
        readonly id: string;
        readonly permissions: {
          readonly teamSuiteDelete: {
            readonly allowed: boolean;
          } | null;
          readonly teamSuiteUpdate: {
            readonly allowed: boolean;
          } | null;
        };
        readonly suite: {
          readonly id: string;
          readonly name: string;
          readonly slug: string;
          readonly url: string;
        } | null;
      } | null;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"ShowMoreFooter_connection">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SuitesChooser_team">;
  readonly " $fragmentType": "Suites_team";
};
export type Suites_team$key = {
  readonly " $data"?: Suites_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"Suites_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowed",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "pageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Suites_team",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SuitesChooser_team"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "pageSize"
        },
        {
          "kind": "Literal",
          "name": "order",
          "value": "NAME"
        }
      ],
      "concreteType": "TeamSuiteConnection",
      "kind": "LinkedField",
      "name": "suites",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ShowMoreFooter_connection"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamSuiteEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamSuite",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accessLevel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Suite",
                  "kind": "LinkedField",
                  "name": "suite",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TeamSuitePermissions",
                  "kind": "LinkedField",
                  "name": "permissions",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Permission",
                      "kind": "LinkedField",
                      "name": "teamSuiteUpdate",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Permission",
                      "kind": "LinkedField",
                      "name": "teamSuiteDelete",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "db6ee1fd2a9f9cc9279d009425056191";

export default node;
